<!--
  Action dialog "Manuelle Buchung".

  IMPORTANT (Design-Gate B-9): This file contains NO form HTML. The input fields are rendered
  by the transient form widget (<mvs-widget> with uiComponent 'form' and an MvsFormDto built
  in the TS) — exactly like the repo precedent wf-process-start.component.html. Everything else
  here is dialog frame, balance preview, and the action button that calls the custom endpoint.
-->
<p-dialog
        header="Manuelle Buchung"
        [visible]="visible"
        (visibleChange)="handleVisibleChange($event)"
        (onShow)="handleShow()"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [style]="{width: '46rem'}"
        [breakpoints]="{'960px': '90vw'}"
        styleClass="cp-provision-agent-manual-booking-dialog">

    @if (busy && !formWidget) {

        <p-skeleton height="18rem"></p-skeleton>

    } @else if (formWidget) {

        <!-- Capture: metadata-driven form widget -->
        <mvs-widget
                [widgetData]="formWidget"
                (onGenericEvent)="handleGenericEvent($event)">
        </mvs-widget>

        <!-- Balance preview -->
        <div class="surface-100 border-round p-3 mt-3">

            <div class="font-semibold mb-2">Saldo-Vorschau</div>

            @if (previewBalanceAfter == null) {

                <span class="text-color-secondary text-sm">
                    Buchungsart und Betrag wählen, um die Wirkung auf das Konto zu sehen.
                </span>

            } @else {

                <div class="flex flex-wrap align-items-center gap-3">

                    <p-tag
                            [value]="previewAccountKind === ProvisionAccountKind.RESERVE_ACCOUNT
                                        ? 'Rücklagenkonto' : 'Provisionskonto'"
                            severity="secondary">
                    </p-tag>

                    <span class="text-color-secondary text-sm">vorher</span>
                    <span class="font-medium">
                        {{ previewBalanceBefore | currency:'EUR':'symbol':'1.2-2' }}
                    </span>

                    <i class="fa-regular fa-arrow-right text-color-secondary"></i>

                    <span class="text-color-secondary text-sm">Buchung</span>
                    <span class="font-medium">
                        {{ previewSignedAmount | currency:'EUR':'symbol':'1.2-2' }}
                    </span>

                    <i class="fa-regular fa-equals text-color-secondary"></i>

                    <span class="text-color-secondary text-sm">nachher</span>
                    <span class="text-xl font-semibold"
                          [class.text-red-500]="previewCausesUnderfunding">
                        {{ previewBalanceAfter | currency:'EUR':'symbol':'1.2-2' }}
                    </span>

                </div>

                @if (previewCausesUnderfunding) {
                    <p-message severity="warn" styleClass="w-full mt-3">
                        <span>
                            Diese Buchung führt das Rücklagenkonto ins Minus und bremst damit die
                            Auszahlung an den Berater.
                        </span>
                    </p-message>
                }

            }

        </div>

        @if (failureMessage) {
            <p-message severity="error" [text]="failureMessage" styleClass="w-full mt-3"></p-message>
        }

    }

    <ng-template pTemplate="footer">
        <p-button
                label="Abbrechen"
                icon="fa-regular fa-xmark"
                severity="secondary"
                [text]="true"
                (onClick)="handleClose()">
        </p-button>

        <p-button
                label="Buchen"
                icon="fa-regular fa-check"
                severity="primary"
                [loading]="busy"
                [disabled]="!submittable"
                (onClick)="handleBook()">
        </p-button>
    </ng-template>

</p-dialog>
